import { Segment } from "semantic-ui-react";

import React from "react";

import secondsToDuration from "astrid-firestore/src/api/articles/utils/secondsToDuration";

import Flex from "../../../../components/Flex/Flex";
import DropdownPortal from "../../../ui/components/DropdownMenu/DropdownPortal";

import useArtifactContentType from "../../hooks/useArtifactContentType";

import ArtfactIcon from "../ArtifactIcon/ArtifactIcon";
import ArtifactStatusLabels from "../ArtifactStatus/ArtifactStatusLabels";

export default function ArtifactSegment({ article, artifact, production, selected, dropdownMenuOptions, ...props }) {
	const created = artifact?.created?.toDate() || new Date();

	const type = useArtifactContentType({ artifact });

	return (
		<Segment {...props}>
			<Flex gap={10} justifyContent="flex-start" style={{ fontSize: "0.95em", lineHeight: "1.3em" }}>
				<ArtfactIcon selected={selected} artifact={artifact} />

				<div style={{ marginRight: "auto" }}>
					{artifact?.name}

					<div style={{ opacity: 0.4, fontSize: "0.9em" }}>
						{type.text}
						{!!artifact?.duration && ` - ${secondsToDuration(artifact.duration, { padHours: 2 })}`}
					</div>
				</div>

				<span style={{ opacity: 0.4, fontSize: "0.9em" }}>
					{created.toLocaleString(undefined, {
						year: "numeric",
						month: "numeric",
						day: "numeric",
						hour: "2-digit",
						minute: "2-digit",
					})}
				</span>

				<ArtifactStatusLabels artifact={artifact} article={article} production={production} />

				{dropdownMenuOptions && <DropdownPortal maxHeight="30vh" options={dropdownMenuOptions} />}
			</Flex>
		</Segment>
	);
}
